<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import DeliveryInfo from '@/components/atoms/restaurant/DeliveryInfo'
import GeneralInfo from '@/components/atoms/restaurant/GeneralInfo'
import Badge from '@/components/molecules/Badge'
import isEmpty from 'lodash.isempty'
import DisplayRate from '@/components/organism/restaurant/DisplayRate'

export default {
    name: 'RestaurantCard',
    components: {
        DisplayRate,
        Badge,
        GeneralInfo,
        DeliveryInfo,
        ImageWrapper,
    },
    props: {
        model: {
            type: Object,
            default: () => undefined,
        },
        canteen: {
            type: String,
            default: undefined,
        },
        carousel: Boolean,
        delay: Boolean,
        brand: Boolean,
        reduce: Boolean,
    },
    data() {
        return {
            show: false,
        }
    },
    computed: {
        hasAddress() {
            return !isEmpty(this.$store.getters['order/address'])
        },
        route() {
            return this.model?.slug && !this.canteen
                ? {
                      name: 'restaurant',
                      params: { slug: this.model?.slug },
                      query: { ...this.$route.query, ...{ card: true } },
                  }
                : undefined
        },
        canteenClosed() {
            return this.canteen ? this.$moment().isAfter(this.canteen, 'minute') : null
        },
        canteenOrderRanOut() {
            return this.canteen && this.model.remaining_order_count >= 0
                ? this.model.remaining_order_count === 0
                : null
        },
        badges() {
            if (!this.model?.badge) return undefined
            return Array.isArray(this.model.badge)
                ? JSON.parse(this.restaurant.badge)
                : [this.model.badge]
        },
        isLink() {
            return !!this.route && !(this.brand && !this.hasAddress)
        },
        distance() {
            return this.$store.getters['site/brandView']
                ? this.model?.delivery?.distance
                : undefined
        },
        rating() {
            return Math.round(this.model?.rating || this.model?.rating_average || 0) / 2
        },
    },
    methods: {
        async onClick(e) {
            if (this.brand && !this.hasAddress) {
                e.preventDefault()
                if (this.$user.isLoggedIn) this.$location.select.open()
                else this.$location.enter.open()
                return
            }

            if (this.canteen) {
                if (!this.canteenClosed && !this.canteenOrderRanOut) this.$emit('click')
            } else if (this.route) await this.$restaurant.fetchRestaurant(this.model?.slug)
        },
    },
}
</script>

<template lang="pug">    
lazy-component(@show="show = true" :class="carousel ? 'slide-card' : 'col-12 col-sm-6 col-md-4 col-lg-4 col-xxl-3 col-xxxl-2'")
    transition(name="restaurant-card") 
        component.restaurant-card(
            :is="isLink ? 'router-link' : 'div'"
            :to="isLink ? route : null"
            :disabled="!route && !canteen"
            v-on.native="isLink ? { click: (e) => onClick(e) } : {}"
            v-on="isLink ? {} : { click: (e) => onClick(e) }"
            :class="{'opacity-50:  pointer-none': delay || (canteen && (canteenClosed || canteenOrderRanOut))}"
            v-if="model")
            template(v-if="!reduce")
                .badge-wrapper.d-flex.flex-wrap.p-4
                    badge(v-if="model.remaining_order_count" type="warning") {{ $t('canteen.limit.remaining') }}&nbsp;{{ model.remaining_order_count }}
                    badge(v-for="(badge, index) in badges" :key="`badge-${index}`" type="warning") {{badge}}
                .position-relative
                    image-wrapper.restaurant-card-image(v-if="show" :src="model.image" background :tag="$t('tags.restaurant_card', {name: model.name})" skeleton-loader fill)
                    delivery-info(:model="model" :canteen="canteen")
                    .canteen-overlay(v-if="canteen && canteenClosed")
                        | {{$t("canteen.time_up")}}
                    .canteen-overlay(v-if="canteen && canteenOrderRanOut")
                        strong {{$t("canteen.limit.title")}}
                        | {{$t("canteen.limit.desc")}}
            .details-wrapper
                transition(name="fade")
                    .favourite(v-if="model.is_user_favorite && !reduce")
                        icon(icon="fa-solid fa-heart")
                h3 {{model.name}}
                .row.mx-n1
                    .px-1.text-ellipsis.w-0(:class="hasAddress ? 'col-12' : 'col'")
                        span.text-m.text-73(v-for="(tag, index) in model.tags"  :class="{'comma': index < model.tags.length }" :key="`tagWithAddress-${model.id}-${_uid}-${index}`") {{tag}}
                    .col.px-1.text-ellipsis(v-if="hasAddress")
                        general-info(:model="model")
                    .col-auto.px-1
                        span.text-warning.font-size-m.font-weight-semibold.line-1(v-if="model.is_new") {{$t('restaurant.new')}}
                        display-rate(:model="model" v-else)
                        span.text-73.font-size-m.line-1.mr-2(v-if="distance") 
                            template(v-if="model.is_new || rating > 0") &nbsp;·&nbsp;
                            | {{distance}} km
</template>
